
/**
 * @export
 * @enum {string}
 */
export enum BillingStatus {
    IN_GOOD_STANDING = 'IN_GOOD_STANDING',
    HARD_LOCK_GENERAL_MESSAGING = 'HARD_LOCK_GENERAL_MESSAGING',
    HARD_LOCK_BILLING_SPECIFIC = 'HARD_LOCK_BILLING_SPECIFIC'
}